// eslint-disable-next-line import/no-unresolved
import LZString from 'https://cdn.skypack.dev/lz-string'

const { CarouselElement } = window.BAO.Carousel
const { useCurrentSlideIndicator } = window.BAO.Carousel.plugins

export class ProductMedia extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide', 'status']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', event => {
      const trigger = event.target.closest('[data-visualiser-try-on]')
      if (trigger) this.handleTryOnClick(event, trigger)
    })
  }

  /**
   * @param {MouseEvent} event
   * @param {HTMLAnchorElement} trigger
   */
  handleTryOnClick (event, trigger) {
    event.preventDefault()

    const fallbackHref = trigger.href

    try {
      const photo = trigger.dataset.defaultPhoto
      if (!photo) throw new Error('No default Try On photo found')

      const placement = this.handleize(trigger.dataset.defaultPlacement)
      const hasPostGroup = trigger.dataset.hasPostGroup === 'true'

      const state = {
        v: 1,
        t: 'ear',
        st: 2,
        ph: photo,
        pl: [{ n: placement, a: true }],
        pr: hasPostGroup
          ? []
          : [
              {
                pl: placement,
                vi: Number(trigger.dataset.variantId),
                id: Number(trigger.dataset.productId),
                pt: 'healed',
                c: trigger.dataset.defaultCollection,
              },
            ],
      }

      const encoded = LZString.compressToEncodedURIComponent(
        JSON.stringify(state),
      )
      if (!encoded) throw new Error('Failed to encode Try On build state')

      const url = new URL(fallbackHref)
      url.searchParams.set('b', encoded)
      window.location.href = url.toString()
    } catch (e) {
      window.location.href = fallbackHref
    }
  }

  /** @param {string} value */
  handleize (value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }

  beforeInitialiseCarousel () {
    this.attachCarouselClasses()
  }

  attachCarouselClasses () {
    this.els.slider.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(slide => {
      slide.classList.add('keen-slider__slide')
    })
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      breakpoints: {
        '(min-width: 901px)': {
          disabled: true,
        },
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    const { element: statusElement } = this.els.status

    return [
      useCurrentSlideIndicator(statusElement, statusElement.dataset.template),
    ]
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
